import { Model } from '@/models/Model';

export class Answer extends Model {
  protected $name = 'Answer';

  protected $endpoint = '/hin/answers';

  protected $primaryKey = 'uuid';

  protected $fillable: string[] = ['hin_report', 'question', 'value'];

  public uuid?: string;

  public key?: string;

  public value = '';

  public question?: Record<string, any>;

  public hin_report?: boolean;
}
